const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domHeader: $('.site-header'),
	classHeaderScroll: 'is-sticky',
	$domHeaderSearch: $('.site-header__search'),
	$domHeaderSearchClose: $('.site-header__search-icon--close'),

	/** @description Initialize */
	init: function() {
		$('.js-search-products').val('');
		this.headerScroll();
		this.headerStickyOnLoad();
		this.searchInputExpand();
		this.clearSearch();
		Global.clickOutsideContainer(Global.$domBody, this.$domHeaderSearch, this.$domHeaderSearchClose, this.searchInputClose.bind(this));
	},

	headerScroll: function() {
		$(document).on('scroll', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},

	headerStickyOnLoad: function() {
		$(window).on('load', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},

	searchInputExpand: function() {
		$('.site-header__search-icon').on('click', function() {
			// eslint-disable-next-line no-unused-vars
			$('.site-header__search, .site-header__search-form-input').toggleClass('is-active');
			$('.site-header__search-icon--close').addClass('js-close');
		});
	},

	searchInputClose: function() {
		$('.site-header__search, .site-header__search-form-input').removeClass('is-active');
		$('.site-header__search-icon--close').addClass('js-close');
		$('.js-search-products').val('');
		$('.js-display-result div.js-products-display').empty();
		$('.js-site-header__shop-search-link span').empty();
		$('.js-site-header__shop-search-link').hide();
	},

	clearSearch: function(){
		let counter = 0;
		$('.site-header__search-icon--close').on('click', function() {
			counter += 1;
			if (counter % 2 === 0) {
				$('.js-search-products').val('');
				$('.js-display-result div.js-products-display').empty();
				$('.js-site-header__shop-search-link span').empty();
				$('.js-site-header__shop-search-link').hide();
			}
		});
	}
};

export default Header;
